import React, { useState, useRef, useEffect } from "react";
import "./VRGamingg.css";

// ✅ NEW: API base for saving inquiries to database
const API_BASE = "https://www.thehexaplay.com/api";

/* ================= SVG ICONS ================= */
const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const WhatsappIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7
      8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8
      8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5
      a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const GamepadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="6" y1="12" x2="10" y2="12" />
    <line x1="8" y1="10" x2="8" y2="14" />
    <line x1="15" y1="13" x2="15.01" y2="13" />
    <line x1="18" y1="11" x2="18.01" y2="11" />
    <rect x="2" y="6" width="20" height="12" rx="2" />
  </svg>
);

const UsersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const ClockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const CallIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2
      19.79 19.79 0 0 1-8.63-3.07
      A19.5 19.5 0 0 1 4.69 13.6
      a19.79 19.79 0 0 1-3.07-8.67
      A2 2 0 0 1 3.6 3h3a2 2 0 0 1 2 1.72
      c.127.96.361 1.903.7 2.81
      a2 2 0 0 1-.45 2.11L7.91 10.6
      a16 16 0 0 0 6.01 6.01l.97-.97
      a2 2 0 0 1 2.11-.45
      c.907.339 1.85.573 2.81.7
      A2 2 0 0 1 22 16.92z" />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ================= HELPERS ================= */
function formatDisplayDate(dateStr) {
  if (!dateStr) return "";
  var parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  var day = parseInt(parts[2], 10);
  var month = months[parseInt(parts[1], 10) - 1];
  var year = parts[0];
  return day + " " + month + " " + year;
}

/* ================= COMPONENT ================= */
function VRGamingg() {
  var today = new Date().toISOString().split("T")[0];

  var initialForm = {
    name: "",
    whatsapp: "",
    date: "",
    location: "",
    game: "",
    persons: "",
    hours: ""
  };

  var _s = useState(initialForm);
  var formData = _s[0];
  var setFormData = _s[1];

  var _s2 = useState({});
  var errors = _s2[0];
  var setErrors = _s2[1];

  var _s3 = useState(false);
  var showPopup = _s3[0];
  var setShowPopup = _s3[1];

  /* Calendar State */
  var _s4 = useState(false);
  var showCalendar = _s4[0];
  var setShowCalendar = _s4[1];

  var _s5 = useState(new Date());
  var viewMonth = _s5[0];
  var setViewMonth = _s5[1];

  var calendarRef = useRef(null);

  /* Lock body scroll when calendar is open */
  useEffect(function () {
    if (showCalendar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return function () { document.body.style.overflow = ""; };
  }, [showCalendar]);

  /* Close calendar on outside click */
  useEffect(function () {
    function handleClick(e) {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    }
    if (showCalendar) {
      document.addEventListener("mousedown", handleClick);
      document.addEventListener("touchstart", handleClick);
    }
    return function () {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  }, [showCalendar]);

  /* ---- Handlers ---- */
  var handleNameChange = function (e) {
    var val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
    setFormData(function (f) { return Object.assign({}, f, { name: val }); });
    if (errors.name) setErrors(function (er) { return Object.assign({}, er, { name: "" }); });
  };

  var handleWhatsappChange = function (e) {
    var val = e.target.value.replace(/\D/g, "").slice(0, 10);
    setFormData(function (f) { return Object.assign({}, f, { whatsapp: val }); });
    if (errors.whatsapp) setErrors(function (er) { return Object.assign({}, er, { whatsapp: "" }); });
  };

  var handleChange = function (field) {
    return function (e) {
      setFormData(function (f) {
        var next = Object.assign({}, f);
        next[field] = e.target.value;
        return next;
      });
      if (errors[field]) {
        setErrors(function (er) {
          var next = Object.assign({}, er);
          next[field] = "";
          return next;
        });
      }
    };
  };

  /* ---- Calendar Logic ---- */
  var openCalendar = function () {
    var base = formData.date ? new Date(formData.date + "T00:00:00") : new Date();
    setViewMonth(new Date(base.getFullYear(), base.getMonth(), 1));
    setShowCalendar(true);
  };

  var prevMonth = function (e) {
    e.stopPropagation();
    setViewMonth(new Date(viewMonth.getFullYear(), viewMonth.getMonth() - 1, 1));
  };

  var nextMonth = function (e) {
    e.stopPropagation();
    setViewMonth(new Date(viewMonth.getFullYear(), viewMonth.getMonth() + 1, 1));
  };

  var selectDate = function (day) {
    var y = viewMonth.getFullYear();
    var m = String(viewMonth.getMonth() + 1).padStart(2, "0");
    var d = String(day).padStart(2, "0");
    var dateStr = y + "-" + m + "-" + d;
    setFormData(function (f) { return Object.assign({}, f, { date: dateStr }); });
    if (errors.date) setErrors(function (er) { return Object.assign({}, er, { date: "" }); });
    setShowCalendar(false);
  };

  var getDaysInMonth = function (date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  var getFirstDay = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  var monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var dayNames = ["Su","Mo","Tu","We","Th","Fr","Sa"];

  var daysInMonth = getDaysInMonth(viewMonth);
  var firstDay = getFirstDay(viewMonth);
  var calendarDays = [];
  for (var i = 0; i < firstDay; i++) calendarDays.push(null);
  for (var d = 1; d <= daysInMonth; d++) calendarDays.push(d);

  /* ---- Validation ---- */
  var validate = function () {
    var err = {};
    if (!formData.name.trim()) err.name = "Name is required";
    else if (formData.name.trim().length < 2) err.name = "Name must be at least 2 characters";
    if (!formData.whatsapp.trim()) err.whatsapp = "WhatsApp number is required";
    else if (!/^[6-9]\d{9}$/.test(formData.whatsapp)) err.whatsapp = "Enter a valid 10-digit WhatsApp number";
    if (!formData.date) err.date = "Please select a date";
    if (!formData.location) err.location = "Please select a location";
    if (!formData.game) err.game = "Please select a game";
    if (!formData.persons) err.persons = "Please select number of persons";
    if (!formData.hours) err.hours = "Please select duration";
    return err;
  };

  /* ---- ✅ UPDATED SUBMIT — Saves to DB FIRST, then opens WhatsApp ---- */
  var handleSubmit = async function (e) {
    e.preventDefault();
    var validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});

    // 1. Save to MongoDB (non-blocking — won't break flow if it fails)
    try {
      await fetch(API_BASE + "/inquiries", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "gaming",
          name: formData.name,
          whatsapp: formData.whatsapp,
          mobile: formData.whatsapp,
          date: formatDisplayDate(formData.date),
          location: formData.location,
          game: formData.game,
          persons: formData.persons,
          hours: formData.hours,
        }),
      });
      console.log("✅ Gaming inquiry saved to DB");
    } catch (err) {
      console.warn("⚠️ Could not save gaming inquiry:", err);
    }

    // 2. Open WhatsApp
    var message =
      "🎮 *VR Gaming Booking Request*\n\n" +
      "👤 Name: " + formData.name + "\n" +
      "📱 WhatsApp: " + formData.whatsapp + "\n" +
      "📅 Date: " + formatDisplayDate(formData.date) + "\n" +
      "📍 Location: " + formData.location + "\n" +
      "🕹 Game: " + formData.game + "\n" +
      "👥 Persons: " + formData.persons + "\n" +
      "⏱ Duration: " + formData.hours;

    var whatsappURL = "https://wa.me/919087775659?text=" + encodeURIComponent(message);
    window.open(whatsappURL, "_blank");

    setShowPopup(true);
    setFormData(initialForm);
  };

  var closePopup = function () { setShowPopup(false); };

  /* ================= RENDER ================= */
  return (
    <section className="vr-hero-section">
      <div className="vr-hero-content">

        <div className="vr-hero-title-block">
          <h1 className="vr-hero-heading">VR &amp; PS5 Gaming Registration</h1>
          <p className="vr-hero-sub">Book Your Immersive Gaming Experience Today</p>
        </div>

        <div className="vr-booking-card">
          <div className="vr-card-title-desktop">
            <h2>VR &amp; PS5 Gaming Registration</h2>
            <p className="vr-booking-sub">Book Your Immersive Gaming Experience Today</p>
          </div>

          <form onSubmit={handleSubmit} noValidate>

            {/* Name */}
            <div className={"vr-input-row" + (errors.name ? " vr-error" : "")}>
              <span className="vr-icon-wrap"><UserIcon /></span>
              <span className="vr-divider" />
              <input type="text" placeholder="Enter your full name" value={formData.name} onChange={handleNameChange} maxLength="50" autoComplete="name" />
            </div>
            {errors.name && <div className="vr-error-msg show">{errors.name}</div>}

            {/* WhatsApp */}
            <div className={"vr-input-row" + (errors.whatsapp ? " vr-error" : "")}>
              <span className="vr-icon-wrap"><WhatsappIcon /></span>
              <span className="vr-divider" />
              <input type="tel" placeholder="Enter WhatsApp number" value={formData.whatsapp} onChange={handleWhatsappChange} maxLength="10" inputMode="numeric" autoComplete="tel" />
            </div>
            {errors.whatsapp && <div className="vr-error-msg show">{errors.whatsapp}</div>}

            {/* Date (Custom Calendar) */}
            <div className={"vr-input-row vr-date-row" + (errors.date ? " vr-error" : "")} onClick={openCalendar}>
              <span className="vr-icon-wrap"><CalendarIcon /></span>
              <span className="vr-divider" />
              <div className="vr-date-display">
                {!formData.date ? (
                  <span className="vr-date-placeholder">Select VR &amp; PS5 gaming date</span>
                ) : (
                  <span className="vr-date-value">{formatDisplayDate(formData.date)}</span>
                )}
              </div>
            </div>
            {errors.date && <div className="vr-error-msg show">{errors.date}</div>}

            {/* Location */}
            <div className={"vr-input-row vr-select-row" + (errors.location ? " vr-error" : "")}>
              <span className="vr-icon-wrap"><MapPinIcon /></span>
              <span className="vr-divider" />
              <select value={formData.location} onChange={handleChange("location")}>
                <option value="" disabled>Select location</option>
                <option value="Chennai">Chennai</option>
                <option value="Pondicherry">Pondicherry</option>
              </select>
              <span className="vr-chevron"><ChevronDownIcon /></span>
            </div>
            {errors.location && <div className="vr-error-msg show">{errors.location}</div>}

            {/* Game */}
            <div className={"vr-input-row vr-select-row" + (errors.game ? " vr-error" : "")}>
              <span className="vr-icon-wrap"><GamepadIcon /></span>
              <span className="vr-divider" />
              <select value={formData.game} onChange={handleChange("game")}>
                <option value="" disabled>Select game</option>
                <option value="VR Gaming">VR Gaming</option>
                <option value="PS5 Gaming">PS5 Gaming</option>
              </select>
              <span className="vr-chevron"><ChevronDownIcon /></span>
            </div>
            {errors.game && <div className="vr-error-msg show">{errors.game}</div>}

            {/* Persons */}
            <div className={"vr-input-row vr-select-row" + (errors.persons ? " vr-error" : "")}>
              <span className="vr-icon-wrap"><UsersIcon /></span>
              <span className="vr-divider" />
              <select value={formData.persons} onChange={handleChange("persons")}>
                <option value="" disabled>Select number of persons</option>
                <option value="1">1 Person</option>
                <option value="2">2 Persons</option>
                <option value="3">3 Persons</option>
                <option value="4">4 Persons</option>
              </select>
              <span className="vr-chevron"><ChevronDownIcon /></span>
            </div>
            {errors.persons && <div className="vr-error-msg show">{errors.persons}</div>}

            {/* Duration */}
            <div className={"vr-input-row vr-select-row" + (errors.hours ? " vr-error" : "")}>
              <span className="vr-icon-wrap"><ClockIcon /></span>
              <span className="vr-divider" />
              <select value={formData.hours} onChange={handleChange("hours")}>
                <option value="" disabled>Select duration</option>
                <option value="30 Minutes">30 Minutes</option>
                <option value="60 Minutes">60 Minutes</option>
                <option value="90 Minutes">90 Minutes</option>
              </select>
              <span className="vr-chevron"><ChevronDownIcon /></span>
            </div>
            {errors.hours && <div className="vr-error-msg show">{errors.hours}</div>}

            <button type="submit" className="vr-book-btn">Book Now</button>
            <a href="tel:+919087775659" className="vr-call-btn"><CallIcon />Book On Call</a>
          </form>
        </div>
      </div>

      {/* Custom Calendar Overlay */}
      {showCalendar && (
        <div className="vr-calendar-overlay">
          <div className="vr-calendar-card" ref={calendarRef} onClick={function(e){ e.stopPropagation(); }}>
            <div className="vr-calendar-header">
              <button type="button" className="vr-cal-nav" onClick={prevMonth} aria-label="Previous month"><ChevronLeftIcon /></button>
              <span className="vr-cal-month-title">{monthNames[viewMonth.getMonth()]} {viewMonth.getFullYear()}</span>
              <button type="button" className="vr-cal-nav" onClick={nextMonth} aria-label="Next month"><ChevronRightIcon /></button>
            </div>

            <div className="vr-cal-weekdays">
              {dayNames.map(function(d){ return <div key={d} className="vr-cal-weekday">{d}</div>; })}
            </div>

            <div className="vr-cal-days">
              {calendarDays.map(function(day, idx){
                if (!day) return <div key={"empty-"+idx} className="vr-cal-day vr-cal-empty"></div>;
                var y = viewMonth.getFullYear();
                var m = String(viewMonth.getMonth() + 1).padStart(2, "0");
                var dStr = String(day).padStart(2, "0");
                var dateStr = y + "-" + m + "-" + dStr;
                var isPast = dateStr < today;
                var isToday = dateStr === today;
                var isSelected = dateStr === formData.date;

                return (
                  <div
                    key={dateStr}
                    className={
                      "vr-cal-day" +
                      (isPast ? " vr-cal-past" : "") +
                      (isToday ? " vr-cal-today" : "") +
                      (isSelected ? " vr-cal-selected" : "")
                    }
                    onClick={isPast ? undefined : function(){ selectDate(day); }}
                  >
                    {day}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Success Popup */}
      {showPopup && (
        <div className="vr-popup-overlay" onClick={closePopup}>
          <div className="vr-popup-card" onClick={function(e){ e.stopPropagation(); }}>
            <div className="vr-popup-icon">🎮</div>
            <h2 className="vr-popup-title">Booking Redirected!</h2>
            <p className="vr-popup-msg">Your booking details have been sent via WhatsApp. We will confirm your session shortly!</p>
            <button className="vr-popup-close" onClick={closePopup}>Done</button>
          </div>
        </div>
      )}
    </section>
  );
}

export default VRGamingg;